"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BronsonValidations = exports.isUrl = exports.startsWith = exports.isPhone = exports.isTaxIdPM = exports.isTaxIdPF = exports.isTaxIdWithHomoclave = exports.isTaxId = exports.hasMinLength = exports.isOnlyDigits = exports.isCurrency = exports.isAlphaNumWithDash = exports.isAlphaNumWithDot = exports.isAlphaNum = exports.isText = exports.isMultiEmail = exports.isEmail = exports.isRequired = exports.isNumber = void 0;
const isNumber = (val) => {
    if (typeof val === 'string') {
        const split = val.split('.');
        if (split.length > 1 && split[1] === '')
            return false;
        val = +val;
    }
    return !isNaN(val);
};
exports.isNumber = isNumber;
const isRequired = (val) => {
    if (val === '' || val === undefined || val === null)
        return false;
    else
        return true;
};
exports.isRequired = isRequired;
const isEmail = (val) => {
    if (typeof val !== 'string')
        return false;
    const re = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-.]+\.[a-zA-Z0-9-.]+$/i;
    return re.test(String(val).toLowerCase()) || val === '';
};
exports.isEmail = isEmail;
const isMultiEmail = (val) => typeof val === 'string' &&
    !val.split(';').filter(mail => !(0, exports.isEmail)(mail.trim())).length;
exports.isMultiEmail = isMultiEmail;
const isText = (val) => {
    if (typeof val !== 'string')
        return false;
    const re = /^[A-Za-zÁÉÍÓÚñáéíóúÑÄËÏÖÜäëïöü\s]+$/i;
    return re.test(String(val).toLowerCase()) || val === '';
};
exports.isText = isText;
const isAlphaNum = (val) => {
    const re = /^[0-9A-Za-zÁÉÍÓÚñáéíóúÑÄËÏÖÜäëïöü\s]+$/i;
    return re.test(String(val).toLowerCase()) || val === '';
};
exports.isAlphaNum = isAlphaNum;
const isAlphaNumWithDot = (val) => {
    const re = /^\s*([0-9A-Za-zÁÉÍÓÚñáéíóúÑÄËÏÖÜäëïöü]\.?\s*)+$/i;
    return re.test(String(val).toLowerCase()) || val === '';
};
exports.isAlphaNumWithDot = isAlphaNumWithDot;
const isAlphaNumWithDash = (val) => {
    const re = /^\s*([0-9A-Za-zÁÉÍÓÚñáéíóúÑÄËÏÖÜäëïöü]\-?\s*)+$/i;
    return re.test(String(val).toLowerCase()) || val === '';
};
exports.isAlphaNumWithDash = isAlphaNumWithDash;
const isCurrency = (val) => {
    const re = /^\s*(?=.*[0-9])\d*(?:\.\d{1,2})?\s*$/g;
    return re.test(String(val).toLowerCase()) || val === '';
};
exports.isCurrency = isCurrency;
const isOnlyDigits = (val) => {
    const re = /\D/;
    return !re.test(String(val).toLowerCase()) || val === '';
};
exports.isOnlyDigits = isOnlyDigits;
const hasMinLength = (val, condition) => {
    if (!val)
        return true;
    return val.toString().length >= (typeof condition === 'string' ? parseInt(condition, 10) : condition);
};
exports.hasMinLength = hasMinLength;
const isTaxId = (val) => {
    const re = /^([A-ZÑ\x26]{3,4}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1]))((-)?([A-Z\d]{3}))?$/;
    return re.test(String(val).toUpperCase()) || val === '';
};
exports.isTaxId = isTaxId;
const isTaxIdWithHomoclave = (val) => {
    const re = /^([A-ZÑ\x26]{3,4}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1]))([A-Z\d]{3})$/;
    return re.test(String(val).toUpperCase()) || val === '';
};
exports.isTaxIdWithHomoclave = isTaxIdWithHomoclave;
const isTaxIdPF = (val) => {
    const re = /^([A-ZÑ\x26]{4}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1]))((-)?([A-Z\d]{3}))?$/;
    return re.test(String(val).toUpperCase()) || val === '';
};
exports.isTaxIdPF = isTaxIdPF;
const isTaxIdPM = (val) => {
    const re = /^([A-ZÑ\x26]{3}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1]))((-)?([A-Z\d]{3}))?$/;
    return re.test(String(val).toUpperCase()) || val === '';
};
exports.isTaxIdPM = isTaxIdPM;
const isPhone = (val) => {
    const re = /^[\d\s]+$/;
    return re.test(String(val)) || val === '';
};
exports.isPhone = isPhone;
const startsWith = (val, startsWith) => {
    if (!val)
        return true;
    return val.toString().startsWith(startsWith.toString());
};
exports.startsWith = startsWith;
const isUrl = (val) => {
    const re = /\b(?:https?:\/\/)?(?:www\.)?[a-zA-Z0-9-]+(?:\.[a-zA-Z]{2,})+(?:\/[^\s]*)?/;
    return re.test(String(val).toUpperCase()) || val === '';
};
exports.isUrl = isUrl;
exports.BronsonValidations = {
    isNumber: exports.isNumber,
    isEmail: exports.isEmail,
    isMultiEmail: exports.isMultiEmail,
    required: exports.isRequired,
    isText: exports.isText,
    isAlphaNum: exports.isAlphaNum,
    isAlphaNumWithDash: exports.isAlphaNumWithDash,
    isAlphaNumWithDot: exports.isAlphaNumWithDot,
    isCurrency: exports.isCurrency,
    isOnlyDigits: exports.isOnlyDigits,
    hasMinLength: exports.hasMinLength,
    isTaxId: exports.isTaxId,
    isTaxIdWithHomoclave: exports.isTaxIdWithHomoclave,
    isTaxIdPF: exports.isTaxIdPF,
    isTaxIdPM: exports.isTaxIdPM,
    isPhone: exports.isPhone,
    startsWith: exports.startsWith,
    isUrl: exports.isUrl,
};
